module.exports = __webpack_public_path__ + "img/ARCvsSBAT-1024x689.158d664a.gif";